import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../common/types';
import { PresaveChecklistItem } from './usePresaveChecklist';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveChecklistRowProps {
  item: PresaveChecklistItem;
}

/** One checklist line: a box, what it found, and the link that fixes it. */
const PresaveChecklistRowComponent: React.FC<PresaveChecklistRowProps> = ({ item }) => {
  return (
    <div className={styles.checklistItem}>
      <span className={clsx(styles.checkbox, item.isDone && styles.checkboxOn)}>
        {item.isDone && <FontAwesomeIcon icon={faCheck} size="xs" />}
      </span>
      <span className={clsx(styles.checklistText, item.isDone && styles.checklistTextOn)}>{item.text}</span>
      {item.actionLabel !== undefined && (
        <button
          type="button"
          className={styles.checklistAction}
          onClick={item.onAction}
          disabled={item.isActionLoading === true}
        >
          {item.actionLabel}
        </button>
      )}
    </div>
  );
};

export const PresaveChecklistRow = TypedMemo(PresaveChecklistRowComponent);
